import { render, staticRenderFns } from "./RecruitmentCvs.vue?vue&type=template&id=15cbd6b4&scoped=true"
import script from "./RecruitmentCvs.vue?vue&type=script&lang=js"
export * from "./RecruitmentCvs.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentCvs.vue?vue&type=style&index=0&id=15cbd6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbd6b4",
  null
  
)

export default component.exports